import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useCallback,
  useImperativeHandle,
  useMemo,
} from "react";
import { fnGetDataSet } from "@shared/api/restApi";
import {
  getInitFormData,
  getNoSlip,
  CalAm,
  CalAmBulk,
} from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SharedForm from "../../../../../widgets/SharedForm";
import { fnSave } from "@shared/api/restApi";
import { menuInfo } from "@shared/type/CommonType";
import { showDialog } from "@widgets/CommonDialog";
import SnGrid from "@shared/components/GridV2/SnGrid";
import SnResizable from "@shared/components/SnResizable";
import usePanelSizes from "@shared/hooks/usePanelSizes";
import { showPopupModal } from "@widgets/CommonModal";
import SN_TRA_ELC_REG_001_POP_001 from "./SN_TRA_ELC_REG_001_POP_001";
import SN_TRA_ELC_REG_001_POP_002 from "./SN_TRA_ELC_REG_001_POP_002";
import { CellValueChangedEvent } from "@shared/components/GridV2/SnGridTypes";
import SnButton from "@shared/components/SnButton";
import SnForm, { ValueChangedEvent } from "@widgets/SnForm";
import { RowNode } from "ag-grid-enterprise";
interface Props {
  Menuprops: menuInfo;
}

interface RowData {
  KeyField?: string; // 행의 고유 ID
  [key: string]: any;
}

const SN_TRA_ELC_REG_001 = forwardRef(({ Menuprops }: Props, ref) => {
  //#region  variable
  const { userInfo } = global(); // Login user 정보
  const gridApiRef1 = useRef<any>(null); // 첫 번째  그리드 Reference 변수
  const gridApiRef2 = useRef<any>(null);
  const SharedFormref1 = useRef<any>();
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
    grid2: React.createRef(),
  });
  const [columns, setColums] = useState<any>({
    grid1: [],
    grid2: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
    grid2: [],
  });
  const formRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    freeform1: React.createRef(),
  });
  const [formControls, setFormControls] = useState<any>({
    freeform1: [],
  });
  const [formDatas, setFormDatas] = useState<any>({
    freeform1: null,
  });

  const today = new Date();
  const todayform = `${today.getFullYear()}${(today.getMonth() + 1)
    .toString()
    .padStart(2, "0")}${today.getDate().toString().padStart(2, "0")}`;

  //#region  Components useState
  const [sharedForm, setSharedForm] = useState<any[]>([]);

  const [columns1, setColums1] = useState<any[]>([]); // gridApiRef1 컬럼 설정 관련
  const [columns2, setColums2] = useState<any[]>([]); // gridApiRef2 컬럼 설정 관련

  const [dataSource1, setDataSource1] = useState<any[]>([]); // gridApiRef1 datasource 관련
  const [dataSource2, setDataSource2] = useState<any>(); // gridApiRef2 datasource 관련

  const [focusedRowData, setFocusedRowData] = useState<any>();
  const [gridFocus1, setGridFocus1] = useState(false);
  const [gridFocus2, setGridFocus2] = useState(false);
  let addedarow = false;

  //#endregion

  //#region panel 사이즈 관련
  const cd_menu = Menuprops.cd_menu || "SN_TRA_ELC_REG_001";
  const defaultSize = {
    panel1: "58.5%",
    panel2: "39.5%",
    panel3: "10.5%",
  };
  const [sizes, onResizeStop] = usePanelSizes(cd_menu, defaultSize); // SnResizable들의 크기

  //#endregion

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setColums({
          grid1: rtn.grid.grid1,
          grid2: rtn.grid.grid2,
        });
        setFormControls({
          freeform1: rtn.form.freeform1,
        });
      } catch (error) {}
    };
    fetchform();
  }, []);

  useEffect(() => {
    gridRefs.current["grid1"].current.selectAndFocusRow(0);
    setGridFocus1(false);
    gridRefs.current["grid2"].current.selectAndFocusRow(0);
    setGridFocus2(false);
  }, [gridFocus1, gridFocus2]);
  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
  }));

  //region OnSearch
  const onSearch = async () => {
    const modifiedRowsH = gridRefs.current["grid1"].current.getChange();
    const modifiedRowsL = gridRefs.current["grid2"].current.getChange();
    if (
      modifiedRowsH.modifiedRowcount > 0 ||
      modifiedRowsL.modifiedRowcount > 0
    ) {
      const confirm = await showDialog(
        "confirm",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
      if (confirm) {
        await onSave();
        return;
      }
    }
    try {
      await search_popup();
    } catch (error) {}
  };
  //region getPopupInitialData
  const getPopupInitialData = () => {
    let cd_cust = "";
    let nm_cust = "";

    if (SharedFormref1.current?.getFormdata) {
      const formData = SharedFormref1.current.getFormdata();
      cd_cust = formData.cd_cust || "";
      nm_cust = formData.nm_cust || "";
    }

    if ((!cd_cust || !nm_cust) && gridRefs.current["grid1"].current) {
      const rowNode = gridRefs.current["grid1"].current.getSelectedRows(0); // always one row
      if (rowNode?.data) {
        cd_cust = cd_cust || rowNode.data.cd_cust || "";
        nm_cust = nm_cust || rowNode.data.nm_cust || "";
      }
    }

    return { cd_cust, nm_cust };
  };
  //region search_popup
  const search_popup = async () => {
    gridRefs.current["grid1"].current.selectAndFocusRow(0);
    await new Promise((resolve) => setTimeout(resolve, 50));

    const selectedData = getPopupInitialData();

    const component = (
      <SN_TRA_ELC_REG_001_POP_001 selectedData={selectedData} />
    );
    const result = await showPopupModal({
      title: "L/C도움",
      children: component,
    });
    if (!result || result === "close") return;
    const headerResult = result[0];
    const newData = { no_lc: headerResult[0].no_lc };
    const params = {
      id: "sn_tra_elc_reg_001_01",
      params: { ...newData },
    };
    const data: any = await fnGetDataSet(params);
    setFormDatas({
      freeform1: data[0][0],
    });
    setDataSources({
      grid1: data[0] || [],
      grid2: data[1] || [],
    });
    setGridFocus1(true);
  };

  //region onInsert
  const onInsert = async () => {
    try {
      const rowChange1 = gridRefs.current["grid1"].current.getChange?.() || {};
      const rowChange2 = gridRefs.current["grid2"].current.getChange?.() || {};
      if (rowChange1.modifiedRowcount > 0 || rowChange2.modifiedRowcount > 0) {
        const confirm = await showDialog(
          "confirm",
          "수정중인 건이 있습니다. 저장하지 않고 계속 하시겠습니까?"
        );
        if (!confirm) return;
      }
      formRefs.current["freeform1"].current.resetUpdate();
      gridRefs.current["grid1"].current?.deleteAllRows();
      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current?.deleteAllRows();
      gridRefs.current["grid2"].current.resetUpdate();

      const updatedRow = {
        cd_firm: userInfo.cd_firm,
        cd_biz: userInfo.cd_biz,
        cd_dept: userInfo.nm_dept,
        nm_dept: userInfo.nm_dept,
        no_hst_amend: 0,
        dy_pay: 0,
        cd_exch: "000",
        rt_exch: 0,
        yn_partial: "Y",
        cd_gp: userInfo.cd_gp,
        nm_gp: userInfo.nm_gp,
        cd_emp: userInfo.cd_emp,
        nm_emp: userInfo.nm_emp,
        dt_lc: todayform,
        dt_start: todayform,
        dt_due: todayform,
        dt_expire: todayform,
        tp_lc: "",
      };
      const newRow = gridRefs.current["grid1"].current.addRow(updatedRow);
      setFormDatas({
        freeform1: newRow.data,
      });
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  //region onDelete
  const onDelete = async () => {
    if (gridRefs.current["grid1"].current.getDisplayedRowCount() === 0) {
      return;
    }
    const confirm = await showDialog("confirm", "삭제 하시겠습니까?");

    if (!confirm) {
      return;
    }

    gridRefs.current["grid2"].current?.deleteAllRows();
    gridRefs.current["grid1"].current?.deleteSelectedRows();
    setFormDatas({
      freeform1: null,
    });
    setTimeout(() => {
      const rowCount =
        gridRefs.current["grid1"].current?.getDisplayedRowCount?.() || 0;
      if (rowCount > 0) {
        const selectedRow = gridRefs.current["grid1"].current.focusedRowNode();
        setFocusedRowData(selectedRow);
      } else {
        setFocusedRowData(undefined);
      }
    }, 100);

    const realDeletedRows =
      gridRefs.current["grid1"].current.getChange().delete ?? [];
    if (Array.isArray(realDeletedRows) && realDeletedRows.length < 1) {
      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      return;
    }
    return await onSave();
  };
  //region onAddRow
  const onAddRow = async () => {
    try {
      gridRefs.current["grid2"].current?.addRow({});
    } catch (error: any) {}
  };
  //region onDeleteRow
  const onDeleteRow = async () => {
    gridRefs.current["grid2"].current?.deleteSelectedRows();
  };

  //region OnSave
  const onSave = async () => {
    try {
      gridRefs.current["grid1"].current.stopEditing();
      gridRefs.current["grid2"].current.stopEditing();

      const requiredValuesCheckH =
        gridRefs.current["grid1"].current.requiredValuesCheck();
      if (!requiredValuesCheckH) {
        return;
      }
      const requiredValuesCheckL =
        gridRefs.current["grid2"].current.requiredValuesCheck();
      if (!requiredValuesCheckL) {
        return;
      }

      const ElchChanges = gridRefs.current["grid1"].current.getChange();
      const ElclChanges = gridRefs.current["grid2"].current.getChange();
      if (
        ElchChanges.modifiedRowcount === 0 &&
        ElclChanges.modifiedRowcount === 0
      ) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }

      const headerInserts = ElchChanges.insert ?? [];
      const lineInserts = ElclChanges.insert ?? [];

      for (let row of headerInserts) {
        if (!row.no_lc) {
          const cd_module: any = Menuprops.cd_module;
          const cd_menu: any = Menuprops.cd_menu;
          try {
            const no_slip = await getNoSlip(
              cd_module,
              1,
              "ELC",
              row.dt_sales,
              cd_menu
            );
            if (no_slip) {
              row.no_lc = no_slip;

              const focusedCell =
                gridRefs.current["grid1"].current.focusedRowNode();

              if (focusedCell) {
                focusedCell.setDataValue("no_lc", no_slip);
              }

              for (let row of lineInserts) {
                if (!row.no_lc) {
                  if (no_slip) {
                    row.no_lc = no_slip;
                  }
                }
              }
              gridRefs.current["grid2"].current.applyFilters({
                no_lc: no_slip,
              });
            }
          } catch (error) {}
        }
      }
      const SaveData = {
        elch: ElchChanges,
        elcl: ElclChanges,
      };

      await fnSave("SN_TRA_ELC_REG_001_SAVE_01", SaveData);

      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
    } catch (error: any) {}
  };

  //region onBeforeAddRowH
  const onBeforeAddRowH = (): any => {
    try {
      const ElchChanges = gridRefs.current["grid1"].current.getChange().insert;
      if (ElchChanges.length > 0) return false;

      const updatedRow = {
        cd_firm: userInfo.cd_firm,
        cd_biz: userInfo.cd_biz,
        cd_dept: userInfo.nm_dept,
        nm_dept: userInfo.nm_dept,
        no_hst_amend: 0,
        dy_pay: 0,
        cd_exch: "000",
        rt_exch: 0,
        yn_partial: "Y",
        cd_gp: userInfo.cd_gp,
        nm_gp: userInfo.nm_gp,
        cd_emp: userInfo.cd_emp,
        nm_emp: userInfo.nm_emp,
        dt_lc: todayform,
        dt_start: todayform,
        dt_due: todayform,
        dt_expire: todayform,
        tp_lc: "",
      };
      return updatedRow;
    } catch (error: any) {
      return false;
    }
  };

  //region onBeforeAddRowL
  const onBeforeAddRowL = (): any => {
    try {
      const allRowData: any[] = [];
      gridRefs.current["grid2"].current.forEachFilteredNode((node: any) => {
        allRowData.push(node.data);
      });
      const maxNoLine =
        gridRefs.current["grid2"].current.getMaxValue("no_line");
      const node = gridRefs.current["grid1"].current.getSelectedRows()[0];
      const noLc = node?.data?.no_lc;

      const updatedRow = {
        cd_firm: userInfo.cd_firm,
        no_lc: noLc,
        dt_dlv: todayform,
        no_hst: 1,
        no_hst_amend: 0,
        no_line: maxNoLine + 1,
      };
      return updatedRow;
    } catch (error: any) {
      return false;
    }
  };
  //region BTNclick
  const onGridBtnsClick = async (id: string) => {
    if (id === "deleteRow") {
      onDeleteRow();
    }
    if (id === "addRow") {
      onAddRow();
    }

    if (id === "aButton_LC") {
      const gridApiH = gridRefs.current["grid1"].current;
      const gridApiL = gridRefs.current["grid2"].current;

      if (!gridApiH || !gridApiL) return;

      const rowCount = gridApiH.getDisplayedRowCount?.() || 0;
      if (rowCount === 0) return;

      const headerRow = gridApiH.getDisplayedRowAtIndex(0)?.data;
      if (!headerRow || !headerRow.no_lc) return;

      try {
        const params = {
          id: "sn_tra_elc_reg_001_01",
          params: {
            cd_firm: userInfo.cd_firm,
            no_lc: headerRow.no_lc,
          },
        };

        const data: any = await fnGetDataSet(params);

        const headerFromApi = data?.[0]?.[0];
        const linesFromApi = data?.[1] || [];

        if (!headerFromApi) {
          return;
        }

        // await new Promise((r) => setTimeout(r, 20));

        const { no_lc, ...headerWithoutNoLc } = headerFromApi;
        gridRefs.current["grid1"].current.addRow({
          ...headerWithoutNoLc,
          no_lc: "",
        });

        linesFromApi.forEach((lineRow: any) => {
          const { no_lc, ...lineWithoutNoLc } = lineRow;
          gridRefs.current["grid2"].current.addRow({
            ...lineWithoutNoLc,
            no_lc: "",
          });
        });

        setTimeout(() => {
          const rowCount =
            gridRefs.current["grid1"].current.getDisplayedRowCount?.() || 0;
          if (rowCount > 0) {
            gridRefs.current["grid1"].current.selectAndFocusRow(0);
          }
        }, 100);
      } catch (error: any) {}
    }

    if (id === "aButton_ORDER") {
      const selectedRows = gridRefs.current["grid1"].current.getSelectedRows();

      if (!selectedRows || selectedRows.length === 0) {
        await showDialog("alter", "신규행을 추가하시기 바랍니다.");
        return;
      }

      const component = <SN_TRA_ELC_REG_001_POP_002 />;
      const result = await showPopupModal({
        title: "수주적용",
        children: component,
        width: "80%",
      });
      if (!result || result === "close") return;

      const lineResult: any[] = result[1];

      lineResult.map((result: any) => {
        const rowNode = gridRefs.current["grid2"].current.addRow?.({});
        const maxNoLine =
          gridRefs.current["grid2"].current.getMaxValue("no_line");

        if (rowNode) {
          rowNode.setDataValue("cd_item", result.cd_item, "noEvent");
          rowNode.setDataValue("nm_item", result.nm_item, "noEvent");
          rowNode.setDataValue("dc_item_spec", result.dc_item_spec, "noEvent");
          rowNode.setDataValue("dc_item_unit", result.dc_item_unit, "noEvent");
          rowNode.setDataValue("qt", result.qt, "noEvent");
          rowNode.setDataValue("um", result.um, "noEvent");
          rowNode.setDataValue("am", result.am, "noEvent");
          rowNode.setDataValue("am_k", result.am_k, "noEvent");
          rowNode.setDataValue("um_k", result.um_k, "noEvent");
          rowNode.setDataValue("dt_dlv", todayform, "noEvent");
          rowNode.setDataValue("no_so", result.no_so, "noEvent");
          rowNode.setDataValue("no_line_so", result.no_line, "noEvent");
        }
      });
      if (lineResult.length > 0) {
        gridRefs.current["grid2"].current.calculateTotals();
        onAfterSetFooter(lineResult);
      }
    }
  };

  //region onFocusedRowChanged
  const onFocusedRowChanged = useCallback(
    (focusedRowData: any | null) => {
      setFormDatas({
        freeform1: focusedRowData,
      });
      const selectedRow = focusedRowData; // 클릭한 행 데이터

      if (selectedRow) {
        // 배열로 만들어서 필터링 함수 호출
        const no_lc = selectedRow.no_lc;
        gridRefs.current["grid2"].current.applyFilters({ no_lc: no_lc });
        gridRefs.current["grid2"].current.selectAndFocusRow(0);
      } else {
        return;
      }
    },
    [formDatas]
  );
  //region OnValueChanged
  const onValueChaged = async (event: ValueChangedEvent) => {
    if (!event) return;

    const colId = event.colId;
    const rowData = event.rowData;
    CalAmBulk(gridRefs.current["grid1"], gridRefs.current["grid2"], colId);
  };
  const onAfterSetFooter = async (data: any) => {
    formRefs.current["freeform1"].current.setDataValue(
      "am",
      data.am,
      "noEvent"
    );
    formRefs.current["freeform1"].current.setDataValue(
      "am_k",
      data.am_k,
      "noEvent"
    );
  };

  const onCellValueChangedL = async (event: CellValueChangedEvent) => {
    if (!event) return;

    const colId = event.colId;
    const rowData = event.rowData;
    const rowNode = event.rowNode;
    await CalAm(
      formRefs.current["freeform1"],
      gridRefs.current["grid1"],
      colId
    );
  };
  //#endregion
  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
        events: {
          onFocusedRowChanged,
          onBeforeAddRow: onBeforeAddRowH,
        },
      },
      grid2: {
        columns: columns.grid2,
        dataSource: dataSources.grid2,
        events: {
          onCellValueChanged: onCellValueChangedL,
          onBeforeAddRow: onBeforeAddRowL,
          onAfterSetFooter: onAfterSetFooter,
          onBtnDeleteClick: onDeleteRow,
        },
      },
    }),
    [columns, dataSources]
  );
  const forms = useMemo(
    () => ({
      freeform1: {
        controls: formControls.freeform1,
        data: formDatas.freeform1,
        etcProps: { gridref: gridRefs.current["grid1"] },
        events: {
          onValueChanged: onValueChaged,
        },
      },
    }),
    [formControls, formDatas]
  );
  //#region  UI
  return (
    <div className="h-full flex flex-col">
      <div className="flex-1 h-full min-h-0 space-y-1.5">
        <SnResizable
          direction={"height"}
          seq={1}
          cd_menu={cd_menu}
          defaultSize={defaultSize}
          size={sizes.panel1}
          onResizeStop={onResizeStop}
          enable={{ bottom: true }}
          minWidth={130}
        >
          <SnForm
            ref={formRefs.current["freeform1"]}
            data={forms.freeform1.data}
            controls={forms.freeform1.controls}
            etcProps={forms.freeform1.etcProps}
            events={forms.freeform1.events}
          ></SnForm>
        </SnResizable>
        <SnResizable
          direction={"height"}
          seq={2}
          cd_menu={cd_menu}
          defaultSize={defaultSize}
          size={sizes.panel2}
          onResizeStop={onResizeStop}
          enable={{ bottom: true }}
          minHeight={130}
        >
          <SnGrid
            ref={gridRefs.current["grid2"]} // Grid Name
            columnConfig={grids.grid2.columns} // 컬럼 설정 전달
            rowData={grids.grid2.dataSource} // Datasource
            etcProps={{
              isEditable: true,
              rowSelection: "multiple",
              title: " ",
            }}
            events={grids.grid2.events}
            header={
              <div>
                <SnButton
                  text={"L/C복사"}
                  onClick={() => {
                    onGridBtnsClick("aButton_LC");
                  }}
                />
                <SnButton
                  text={"수주적용"}
                  onClick={() => {
                    onGridBtnsClick("aButton_ORDER");
                  }}
                />
              </div>
            }
          />
        </SnResizable>
        <div style={{ opacity: 0 }}>
          <SnResizable
            direction={"height"}
            seq={3}
            cd_menu={cd_menu}
            defaultSize={defaultSize}
            size={sizes.panel3}
            onResizeStop={onResizeStop}
            enable={{ bottom: true }}
            minWidth={130}
          >
            <SnGrid
              ref={gridRefs.current["grid1"]} // Grid Name
              columnConfig={grids.grid1.columns} // 컬럼 설정 전달
              rowData={grids.grid1.dataSource} // Datasource
              etcProps={{
                isEditable: true,
                rowSelection: "single",
              }}
              events={grids.grid1.events}
            />
          </SnResizable>
        </div>
      </div>
    </div>
  );
  //#endregion
});
export default SN_TRA_ELC_REG_001;
